import React from "react";

/**
 * Lodgy.co brand logo — inline SVG so it themes with CSS and prints crisp.
 *
 * Variants:
 *  - "full"  → icon + wordmark "Lodgy.co"
 *  - "icon"  → just the plus-cross mark (for favicons, tight sidebars)
 *
 * Colour scheme (from brand guide):
 *  - Cross accents: teal (#11A285) + warm (#FF990A) + white/navy
 *  - Wordmark colour follows the surrounding text colour via `currentColor`
 *    so the same logo works on light AND dark surfaces (sidebar).
 *  - `dotColor` is optional — for the coloured `.co` dot; defaults to teal.
 */
export function LodgyLogo({
  variant = "full",
  size = 32,
  className = "",
  dotColor = "#11A285",
}) {
  const height = size;
  const iconSize = height;

  const Icon = (
    <svg
      viewBox="0 0 64 64"
      width={iconSize}
      height={iconSize}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      style={{ flexShrink: 0 }}
    >
      {/* teal top bar */}
      <rect x="26" y="4" width="12" height="22" rx="6" fill="#11A285" />
      {/* warm left bar */}
      <rect x="4" y="26" width="22" height="12" rx="6" fill="#FF990A" />
      {/* dark navy right bar */}
      <rect x="38" y="26" width="22" height="12" rx="6" fill="currentColor" />
      {/* white/navy bottom bar */}
      <rect x="26" y="38" width="12" height="22" rx="6" fill="currentColor" opacity="0.9" />
    </svg>
  );

  if (variant === "icon") {
    return <span className={className}>{Icon}</span>;
  }

  return (
    <span
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: `${Math.max(6, size * 0.2)}px`,
        fontFamily: '"Proxima Nova", Montserrat, Inter, sans-serif',
        fontWeight: 800,
        letterSpacing: "-0.02em",
        lineHeight: 1,
      }}
    >
      {Icon}
      <span style={{ fontSize: size * 0.9, color: "currentColor" }}>
        Lodgy<span style={{ color: dotColor }}>.co</span>
      </span>
    </span>
  );
}

export default LodgyLogo;
